export default __webpack_public_path__ + "static/panel-desktop-ccf9c72b00dccf669784383f0c2f7cde.png";